module.exports = __webpack_public_path__ + "img/welcome-browse.6217befb.svg";